import React from 'react';
import { LazyMotion, domAnimation, m } from "framer-motion";
import './OrangeSpinner.css'
import { useRef, useEffect } from 'react';
import * as THREE from 'three';
import gsap from 'gsap';
import { useTranslation } from 'react-i18next';
const AdvancedOrangeSpinner = () => {
  const orangeVariants = {
    start: { opacity: 0, y: -20 },
    end: { opacity: 1, y: 0, transition: { staggerChildren: 0.2 } }
  };

  const dotVariants = {
    start: { opacity: 0, y: -10 },
    end: { opacity: 1, y: 0 }
  };

  const canvasRef = useRef();
  const { t } = useTranslation('global');

  useEffect(() => {
    // إعداد مشهد النجوم
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 80;
    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x000000, 0);
    if (canvasRef.current) {
      canvasRef.current.appendChild(renderer.domElement);
    }
    // نجوم
    const starsGeometry = new THREE.BufferGeometry();
    const starCount = 120;
    const positions = [];
    for (let i = 0; i < starCount; i++) {
      positions.push(
        (Math.random() - 0.5) * window.innerWidth,
        (Math.random() - 0.5) * window.innerHeight,
        Math.random() * -200
      );
    }
    starsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    const starsMaterial = new THREE.PointsMaterial({ color: 0x000c3d, size: 2 });
    const stars = new THREE.Points(starsGeometry, starsMaterial);
    scene.add(stars);
    gsap.to(stars.rotation, { y: Math.PI * 2, duration: 18, repeat: -1, ease: 'linear' });
    let running = true;
    function animate() {
      if (!running) return;
      renderer.render(scene, camera);
      requestAnimationFrame(animate);
    }
    animate();
    return () => {
      running = false;
      renderer.dispose();
      if (canvasRef.current) {
        canvasRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="advanced-spinner-overlay" style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.12)' }}>
      <div ref={canvasRef} style={{ position: 'absolute', inset: 0, width: '100vw', height: '100vh', zIndex: 0, pointerEvents: 'none' }} />
      <LazyMotion features={domAnimation}>
        <m.div
          initial="start"
          animate="end"
          variants={orangeVariants}
          className="advanced-spinner-container"
          style={{ position: 'relative', zIndex: 1 }}
        >
          <m.div
            className="advanced-spinner"
            style={{
              background: 'linear-gradient(135deg, #000c3d, #233a6c)',
              boxShadow: '0 0 20px rgba(0, 12, 61, 0.3)'
            }}
            animate={{ rotate: 360 }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
          />
          
          <m.div className="dots-container" style={{marginRight : "-30px"}}>
            {[...Array(3)].map((_, i) => (
              <m.span
                key={i}
                variants={dotVariants}
                style={{ backgroundColor: '#000c3d' }}
                animate={{
                  y: [0, -10, 0],
                  opacity: [0.6, 1, 0.6]
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  delay: i * 0.2
                }}
              />
            ))}
          </m.div>
          
          <m.p 
            style={{ color: '#222 !important' }}
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            {t('loading')}
          </m.p>
        </m.div>
      </LazyMotion>
    </div>
  );
};

export default AdvancedOrangeSpinner;
